import { render } from "./SearchField.vue?vue&type=template&id=b1a588ec&scoped=true"
import script from "./SearchField.vue?vue&type=script&lang=js"
export * from "./SearchField.vue?vue&type=script&lang=js"

import "./SearchField.vue?vue&type=style&index=0&id=b1a588ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b1a588ec"

export default script